/* projects/speaker-platform/src/app/organisms/admin/speaker-edit-contactdetails/speaker-edit-contactdetails.component.scss */
/*# sourceMappingURL=speaker-edit-contactdetails.component-MZ73CEIV.css.map */
